export const FFC_LOCAL_STORAGE = "viewFulfillmentCenters";
export const IN_STOCK_PRODUCTS_LOCAL_STORAGE = "viewInStockProducts";
export const PURCHASED_BEFORE_LOCAL_STORAGE = "viewPurchasedBeforeProducts";
export const USER_ID_LOCAL_STORAGE = "user-id";
export const NAVIGATION_OUTLINE = "navigationOutline";
export const LOCAL_PRODUCT_CONFIGURATIONS_LOCAL_STORAGE = "localProductConfigurations";
export const COMPARE_PRODUCTS_LOCAL_STORAGE = "compareProducts";
export const INITIALIZE_APP_CACHE_KEY_PREFIX = "vc:initialStore:v1:";
